import { InjectionToken } from '@angular/core';
import { Leerkr8Objective } from '@core/saves/leerkr8/types';
import { WordStatistic } from '@core/wk8/word-statistic.service';
import { VariableValues } from '@features/lp/lp-variables/lp-variables.service';
import { LabelStatistic } from '@features/wk8/adaptivity.service';
import { Observable } from 'rxjs';

export const SAVE_SERVICE = new InjectionToken<ISavesManager>('save service provider');

export interface ProgressRecord {
  uid: string;
  // ISO formatted datetime
  finished_timestamp?: string;
  started_timestamp?: string;
}

export type WordProgressRecord = {
  uid: string;
  savedFilterOptions?: string[]; // uids of the picked LpWoordData
  word?: string; // the word the player chose for this spot
  finished_timestamp?: string; // the ISO datetime when the player chose the word
};

export type ReadSpeed = {
  speed: number; // ms per klank
  n: number; // number of measurements
};

export interface ISaveState {
  /**
   * The progress of the missions
   */

  /**
   * The progress of the missions and activities
   */
  missionProgress: ProgressRecord[];
  activityProgress: ProgressRecord[];
  /**
   * A mapping from variableref (id) to the value of the variable.
   */
  variables: VariableValues;
  /**
   * List of item uids in the inventory
   */
  // TODO: inventory is never updated, but this isn't used in Woordkr8 for now so can be implemented later
  // inventory: string[];

  wordStatistics: WordStatistic[];

  labelStatistics: LabelStatistic[];

  seenMechanicIntros: string[];

  wordProgress: WordProgressRecord[];

  planetProgress: { planetUid: string; books: { uid: string; finished_timestamp: string | undefined }[] }[]; // Progress of planets and their books. the planets and books appear in the correct order

  readSpeed: ReadSpeed;
}

export interface ISavesManager {
  /**
   * Emits the playerCode or relevant value when a player logs in.
   */
  onLogin$: Observable<string>;

  addPlaythroughObjective(objectives: Leerkr8Objective): void;

  save(state: Partial<ISaveState>): Promise<void>;
  load(): Promise<ISaveState>;

  login(playerCode: string): Promise<void>;

  logout(): void;

  isLoggedIn(): boolean;

  startPolling(): Promise<void>;

  stopPolling(): Promise<void>;
}

export enum SaveServiceProvider {
  // eslint-disable-next-line no-unused-vars
  LEERKR8 = 'LEERKR8',
  // eslint-disable-next-line no-unused-vars
  LOCAL_STORAGE = 'LOCAL_STORAGE',
  // eslint-disable-next-line no-unused-vars
  DONT_SAVE = 'DONT_SAVE',
  // eslint-disable-next-line no-unused-vars
  MEMORY = 'MEMORY',
}

export function getDefaultSaveState(): ISaveState {
  return {
    activityProgress: [],
    missionProgress: [],
    variables: {},
    wordStatistics: [],
    labelStatistics: [],
    seenMechanicIntros: [],
    wordProgress: [],
    planetProgress: [],
    readSpeed: { n: 0, speed: 2000 },
  };
}
